const EmailConfigTables = Object.freeze({
  AuthorizedSendersTeam: 1,
  AdditionalRecipientsTeam: 2,
  AuthorizedSendersMember: 3,
  AdditionalRecipientsMember: 4,
  NonNatcaMembers: 5,
  DefaultMembers: 6,
  AdditionalRecipientsFacilityRep: 7,
});
export default EmailConfigTables;
